var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.webNavigator == "pc"
    ? _c(
        "div",
        { class: [this.$route.path == "/" ? "row-8" : "row-9", "positionRE"] },
        [
          _c(
            "div",
            { class: [this.$route.path == "/" ? "buttons" : "bottomOll"] },
            [
              _c(
                "div",
                { staticClass: "deep-line" },
                [
                  _c("div", { staticClass: "footer-box" }, [
                    _c("div", { staticClass: "footer-box-title" }, [
                      _vm._v("关于我们")
                    ]),
                    _c(
                      "div",
                      { staticClass: "feed" },
                      _vm._l(_vm.secondTypeList1, function(item, index) {
                        return _c(
                          "a",
                          { key: index, attrs: { href: item.hrefs } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticClass: "feed" },
                      _vm._l(_vm.secondTypeList2, function(item, index) {
                        return _c(
                          "a",
                          { key: index, attrs: { href: item.hrefs } },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._l(_vm.endlist, function(item, index) {
                    return item.name.indexOf("知识") > -1
                      ? _c(
                          "div",
                          {
                            key: index,
                            class:
                              index == _vm.endlist.length - 1
                                ? "footer-last-box"
                                : "footer-box"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "footer-box-title",
                                on: {
                                  click: function($event) {
                                    return _vm.path(item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.name) +
                                    "\n          "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "feed" },
                              _vm._l(item.data, function(item1, index) {
                                return index <= 2
                                  ? _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "link-name",
                                        on: {
                                          click: function($event) {
                                            return _vm.path2(item1, item, index)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item1.text) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  _c("div", { staticClass: "footer-box-title" }, [
                    _vm._v("合作伙伴")
                  ]),
                  _c(
                    "div",
                    { staticClass: "feed" },
                    _vm._l(_vm.secondTypeList3, function(item, index) {
                      return _c(
                        "a",
                        { key: index, attrs: { href: item.hrefs } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.$route.path == "/",
                      expression: "this.$route.path=='/'"
                    }
                  ],
                  staticClass: "friendLink"
                },
                [
                  _c("div", { staticClass: "footer-box-title" }, [
                    _vm._v("友情链接：")
                  ]),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "https://www.gufangyiyuan.cn/" }
                    },
                    [_vm._v("谷方益元")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "http://www.zetanmijia.cn/" }
                    },
                    [_vm._v("正糖名家")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "https://www.renshen365.com" }
                    },
                    [_vm._v("长白山人参")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "https://www.meidouya.com" }
                    },
                    [_vm._v("健康养生")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "http://www.rrjkw.net" }
                    },
                    [_vm._v("人人健康")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "http://www.rzebhkyy.com/" }
                    },
                    [_vm._v("山东省耳鼻喉医院")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "http://jianfei99.cn" }
                    },
                    [_vm._v("减肥网")]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "linkstyle",
                      attrs: { href: "http://www.skrd168.com" }
                    },
                    [_vm._v("尿碘检测仪")]
                  )
                ]
              )
            ]
          ),
          _c("div", { staticClass: "deep-line2 flexSpace" }, [
            _c("div", { staticClass: "code2" }, [
              _c("img", { attrs: { src: _vm.src, title: "", alt: "" } }),
              _c("div", { staticClass: "code2-content" }, [
                _vm._v("扫码关注脂玫乐公众号")
              ])
            ]),
            _c("div", { staticClass: "code2" }, [
              _c("img", { attrs: { src: _vm.src1, title: "", alt: "" } }),
              _c("div", { staticClass: "code2-content" }, [
                _vm._v("扫描下载脂玫乐app")
              ])
            ]),
            _c("div", { staticClass: "address flexStart" }, [
              _c("img", {
                staticClass: "displayIB address-img",
                attrs: { src: _vm.src2, title: "" }
              }),
              _vm._m(0)
            ]),
            _c("div", { staticClass: "phone-number flexStart" }, [
              _c("img", {
                staticClass: "phone-number-img",
                attrs: { src: _vm.src3, title: "" }
              }),
              _c("div", { staticClass: "phone-number-content" }, [
                _vm._v("400-6090-399")
              ])
            ]),
            _c("img", {
              staticClass: "code",
              attrs: { src: _vm.src4, title: "" }
            }),
            _c("div", { staticClass: "share" }, [
              _c("div", { staticClass: "d-hover positionRE" }, [
                _c("div", { staticClass: "code-item hsItem" }),
                _c("img", {
                  staticClass: "code-item-big positionAB",
                  attrs: { src: _vm.src5, title: "" }
                })
              ]),
              _c("div", { staticClass: "d-hover positionRE" }, [
                _c("div", { staticClass: "code-item dyItem" }),
                _c("img", {
                  staticClass: "code-item-big positionAB",
                  attrs: { src: _vm.src6, title: "" }
                })
              ]),
              _vm._m(1),
              _vm._m(2)
            ])
          ]),
          _vm._m(3)
        ]
      )
    : _c("div", [
        _c("div", { staticClass: "phone-fotNav" }, [
          _c("div", { staticClass: "fotNav-Box" }, [
            _c(
              "div",
              { staticClass: "fotNav-topBox" },
              _vm._l(_vm.navList, function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "fotNav-ListBox" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fotNav-Tlt",
                        on: {
                          click: function($event) {
                            return _vm.goNav(item, index)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.name) +
                            "\n            "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "fotNav-ListP" },
                      _vm._l(item.children, function(item2, index2) {
                        return _c(
                          "div",
                          {
                            key: index2,
                            staticClass: "fotNav-P",
                            on: {
                              click: function($event) {
                                return _vm.goNav(item2, index2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item2.name) +
                                "\n              "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              }),
              0
            ),
            _c("div", { staticClass: "fotNav-topBoxloge" }, [
              _c(
                "div",
                {
                  staticClass: "min-box",
                  on: {
                    click: function($event) {
                      return _vm.downloadApp(1)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { src: _vm.phone1, title: "", alt: "" }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "min-box",
                  on: {
                    click: function($event) {
                      return _vm.downloadApp(2)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { src: _vm.phone2, title: "", alt: "" }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "min-box",
                  on: {
                    click: function($event) {
                      return _vm.downloadApp(3)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { src: _vm.phone3, title: "", alt: "" }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "min-box",
                  on: {
                    click: function($event) {
                      return _vm.downloadApp(4)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: { src: _vm.phone4, title: "", alt: "" }
                  })
                ]
              )
            ]),
            _c("div", { staticClass: "fotNav-fotBox" }, [
              _c("div", { staticClass: "fotNav2-ewmBox" }, [
                _c("img", {
                  staticClass: "fotNav2-ewm",
                  attrs: {
                    src: _vm.phone5,
                    title: "",
                    alt: "扫码关注脂玫乐公众号"
                  }
                }),
                _vm._m(4)
              ]),
              _vm._m(5)
            ])
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: this.$route.path == "/",
                  expression: "this.$route.path=='/'"
                }
              ],
              staticClass: "friendLink"
            },
            [
              _c("div", { staticClass: "footer-box-title1" }, [
                _vm._v("友情链接：")
              ]),
              _vm._m(6)
            ]
          )
        ]),
        _vm._m(7)
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "displayIB" }, [
      _c("div", { staticClass: "address-content" }, [
        _vm._v("湖南省长沙市高新开发区汇智中路179号")
      ]),
      _c("div", { staticClass: "address-content" }, [
        _vm._v("金荣同心工业园C6栋")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-hover" }, [
      _c("a", {
        staticClass: "code-item ttItem",
        attrs: {
          rel: "external nofollow",
          href:
            "https://www.toutiao.com/c/user/619748942939964/#mid=1627878775647236"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-hover" }, [
      _c("a", {
        staticClass: "wbItem",
        attrs: {
          rel: "external nofollow",
          href: "https://weibo.com/u/6259280293"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-copy" }, [
      _c(
        "a",
        {
          staticStyle: { color: "#fff" },
          attrs: {
            rel: "external nofollow",
            href: "https://beian.miit.gov.cn/#/Integrated/index"
          }
        },
        [_vm._v("湘ICP备17011020号-3")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "colffffff font17phone fotNav2-ewmP" }, [
      _vm._v("\n              扫码关注 "),
      _c("br"),
      _vm._v("脂玫乐公众号\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fotNav2-TextBox colffffff displayIB" }, [
      _c("div", { staticClass: "font20phone" }, [
        _c("span", { staticClass: "fotNav2-map" }),
        _c("div", { staticClass: "displayIB fotNav2-Text" }, [
          _vm._v(
            "\n                湖南省长沙市高新开发区汇智中路179 号金荣同心工业园C6栋\n              "
          )
        ])
      ]),
      _c("div", { staticClass: "font36phone fontWeightB" }, [
        _c("span", { staticClass: "fotNav2-phone" }),
        _c("div", { staticClass: "fotNav2-Text2 displayIB" }, [
          _vm._v("400-6090-399")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aLink" }, [
      _c(
        "a",
        {
          staticClass: "linkstyle",
          attrs: { href: "https://www.gufangyiyuan.cn/" }
        },
        [_vm._v("谷方益元")]
      ),
      _c(
        "a",
        {
          staticClass: "linkstyle",
          attrs: { href: "http://www.zetanmijia.cn/" }
        },
        [_vm._v("正糖名家")]
      ),
      _c(
        "a",
        {
          staticClass: "linkstyle",
          attrs: { href: "https://www.renshen365.com" }
        },
        [_vm._v("长白山人参")]
      ),
      _c(
        "a",
        {
          staticClass: "linkstyle",
          attrs: { href: "https://www.meidouya.com" }
        },
        [_vm._v("健康养生")]
      ),
      _c(
        "a",
        { staticClass: "linkstyle", attrs: { href: "http://www.rrjkw.net" } },
        [_vm._v("人人健康")]
      ),
      _c(
        "a",
        {
          staticClass: "linkstyle",
          attrs: { href: "http://www.rzebhkyy.com/" }
        },
        [_vm._v("山东省耳鼻喉医院")]
      ),
      _c(
        "a",
        { staticClass: "linkstyle", attrs: { href: "http://jianfei99.cn" } },
        [_vm._v("减肥网")]
      ),
      _c(
        "a",
        { staticClass: "linkstyle", attrs: { href: "http://www.skrd168.com" } },
        [_vm._v("尿碘检测仪")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fotNav2-copyright" }, [
      _c(
        "a",
        {
          staticClass: "col99999 font16phone",
          attrs: {
            rel: "external nofollow",
            href: "http://www.beian.miit.gov.cn/"
          }
        },
        [_vm._v("湘ICP备17011020号-3")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-166596af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166596af","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterNavigation/FooterNavigation.vue
// module id = 780
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17